import React from 'react';

import Filters from 'components/shared/Filters/Filters';
import DisplayButton from 'components/shared/DisplayButton/DisplayButton';

const DEFAULT_FILTERS_DEFS = {
  name: {
    title: 'Name',
    values: null,
    allowed_operators: ['contains', 'does not contain'],
    icon: 'editor-text-mono'
  },
  self_pay: {
    title: 'Self pay',
    type: 'number',
    values: null,
    icon: 'dollar-circle-mono'
  }
};

const TableFilters = ({ filters, changeFilters, columnDefs, onColumnChange, onColumnDragEnd }) => {
  return (
    <div className="relative z-20 flex items-center justify-between gap-2 border-0 border-b border-solid border-neutral-200 bg-white px-4 py-2 [&_.right-0]:!-right-5">
      <Filters
        defaultFilters={DEFAULT_FILTERS_DEFS}
        filters={filters || {}}
        changeFilters={changeFilters}
        position="left"
      />
      <DisplayButton
        columns={columnDefs}
        onColumnChange={onColumnChange}
        onDragEnd={onColumnDragEnd}
        pin={false}
      />
    </div>
  );
};

export default TableFilters;
